export const SELF_SERVE_STEP_PATHNAMES = ['/reserve/1', '/reserve/2', '/reserve/3'];

export const OLD_ALL_ACCESS_FREE_TRIAL_PLAN_REF = 'all_access';
export const ALL_ACCESS_FREE_TRIAL_PLAN_REF = 'aa';
export const ALL_ACCESS_FREE_TRIAL_PLAN_REFS = [OLD_ALL_ACCESS_FREE_TRIAL_PLAN_REF, ALL_ACCESS_FREE_TRIAL_PLAN_REF];

export const RESERVABLE_TYPES = {
  hotDesk: 'HotDesk',
  dedicatedDesk: 'DedicatedDesk',
  sharedOfficeDesk: 'SharedOfficeDesk',
  office: 'Office',
  allAccess: 'AllAccess'
};

export const RESERVABLE_TYPE_TO_MESSAGE = {
  [RESERVABLE_TYPES.hotDesk]: 'hotDesk',
  [RESERVABLE_TYPES.allAccess]: 'allAccess',
  [RESERVABLE_TYPES.dedicatedDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.sharedOfficeDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.office]: 'privateOffice'
};

export const MARKET_FILTER_DATE_VALUES = {
  thisMonth: 'this_month',
  nextMonth: 'next_month',
  other: 'other'
};

export const MAX_DAYS_AWAY_TO_ALLOW_MOVE_IN = 42;

export const AMENITIES = {
  mailAndPackaging: 'mailAndPackaging',
  privateOfficeConferenceRoomCredits: 'privateOfficeConferenceRoomCredits',
  deskConferenceRoomCredits: 'deskConferenceRoomCredits',
  printingCredits: 'printingCredits',
  furnished: 'furnished'
};

export const FLOORPLAN_ASSET_BASE_URL = 'https://www-floorplan-assets.imgix.net';

export const ALL_ACCESS_PRODUCT_UUID = 'ca04dfa5-b8f4-4c80-b36e-f9547a23f654';
export const ALL_ACCESS_FREE_TRIAL_PRODUCT_UUID = '46b2785e-ff00-4401-82c7-31009328448b';

export const ON_DEMAND_COUNTRY_ALLOWLIST = ['US'];

export const ALL_ACCESS_COUNTRY_ALLOWLIST = ['US', 'GB', 'FR', 'IT', 'ES', 'BE', 'IE', 'DE'];

export const HOT_DESK_DEPRECATED_COUNTRIES = ['CA', 'GB', 'US', 'IT', 'ES', 'DE', 'IE', 'BE', 'FR'];

export const LOOKUP__COUNTRY_ISO_TO_BILLING_ENTITY = {
  CA: 'cec7a8c2-4a49-4db0-8b89-53c80e2fa83a', // United States Billing Entity
  GB: 'dcb693ea-78d2-4a11-bbf4-11130b3122bf', // Great Britain Billing Entity
  US: 'cec7a8c2-4a49-4db0-8b89-53c80e2fa83a', // United States Billing Entity
  IT: 'ba036459-5585-4d7f-9dd5-526bfd9aaf5d', // Italy Billing Entity,
  ES: '22498409-bd4d-4986-8242-526a24ef543d', // Spain Billing Entity,
  DE: '29874470-e555-457c-8637-0b346ae83c4d', // Germany (Friesenplatz 4) Billing Entity,
  IE: 'f4d12c39-2a7e-4db1-8744-a39ab2dd99b2', // Ireland (Central Plaza) Billing Entity,
  BE: 'c3120f74-984f-42f8-b962-84e6ebf5f5b6', // Belgium Billing Entity,
  FR: '3e18355f-a805-4732-a8fd-30f206492a5d' // France Billing Entity
};

export const LOOKUP__COUNTRY_ISO_TO_UUID = {
  GB: 'a72000e4-1ea7-11e6-ab4a-0a488af3e541', // United Kingdom Country UUID
  CA: 'a64938f2-1ea7-11e6-ab4a-0a488af3e541', // Canada Country UUID
  FR: '0f1274fe-22d9-11e6-8807-0a488af3e541', // France Country UUID
  BR: '85634b04-31b8-11e6-85d9-0a488af3e541', // Brazil Country UUID
  MX: 'a44de3c2-1ea7-11e6-ab4a-0a488af3e541', // Mexico UUID
  DE: 'a52254cc-1ea7-11e6-ab4a-0a488af3e541', // Germany UUID
  US: 'a4620adc-1ea7-11e6-ab4a-0a488af3e541', // United States UUID
  IE: '88be8502-31b8-11e6-85d9-0a488af3e541', // Ireland UUID
  BE: '84ce6a0c-31b8-11e6-85d9-0a488af3e541', // Belgium UUID
  IT: '891a94b4-31b8-11e6-85d9-0a488af3e541', // Italy UUID
  ES: '8713da5e-31b8-11e6-85d9-0a488af3e541', // Spain UUID
  AU: '64acbbf0-2922-11e6-bdd3-0a488af3e541', // Australia UUID
  SE: '8d525580-31b8-11e6-85d9-0a488af3e541', // Sweden UUID
  PL: '8c731456-31b8-11e6-85d9-0a488af3e541', // Poland UUID
  CZ: '868cac3c-31b8-11e6-85d9-0a488af3e541', // Czech Republic UUID
  NO: '8bc409de-31b8-11e6-85d9-0a488af3e541', // Norway UUID
  NL: 'a5c40dee-1ea7-11e6-ab4a-0a488af3e541', // Netherlands UUID
  SG: '8d5f19b4-31b8-11e6-85d9-0a488af3e541', // Singapore UUID
  AE: '83c1b916-31b8-11e6-85d9-0a488af3e541' // United Arab Emirates UUID
};
